var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05882 0C4.48411 0 5.68172 0.974826 6.02128 2.29412H12.2353V3.82353H6.02128C5.68172 5.14282 4.48411 6.11765 3.05882 6.11765C1.36948 6.11765 0 4.74817 0 3.05882C0 1.36948 1.36948 0 3.05882 0ZM3.05882 4.58824C3.90349 4.58824 4.58823 3.90349 4.58823 3.05882C4.58823 2.21415 3.90349 1.52941 3.05882 1.52941C2.21415 1.52941 1.52941 2.21415 1.52941 3.05882C1.52941 3.90349 2.21415 4.58824 3.05882 4.58824Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7059 13C9.28059 13 8.08299 12.0252 7.74342 10.7059H1.52941V9.17647H7.74342C8.08299 7.85718 9.28059 6.88235 10.7059 6.88235C12.3952 6.88235 13.7647 8.25183 13.7647 9.94118C13.7647 11.6305 12.3952 13 10.7059 13ZM10.7059 11.4706C11.5506 11.4706 12.2353 10.7858 12.2353 9.94118C12.2353 9.09651 11.5506 8.41176 10.7059 8.41176C9.86121 8.41176 9.17647 9.09651 9.17647 9.94118C9.17647 10.7858 9.86121 11.4706 10.7059 11.4706Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/iconFilter.98260ad63373d1eb432c68470775ec10.svg";
export { ForwardRef as ReactComponent };